export function handleDependencies({
  dependencyKeys,
  fieldSchema,
  formData,
  path,
  field,
  currentFormData,
}) {
  let updatedFieldSchema = fieldSchema;
  let updatedFormData = currentFormData;

  for (const dep of dependencyKeys) {
    const depSchema = updatedFieldSchema?.dependencies?.[dep.key];
    if (!depSchema?.oneOf) continue;

    let selectedValue;

    if (dep.section === "insurance") {
      selectedValue = formData?.insurance?.insuranceTerm?.[dep.key];
    } else {
      selectedValue = formData?.[dep.section]?.[dep.key];
    }

    const matchedBranch = depSchema.oneOf.find((branch) => {
      const branchField = branch.properties?.[dep.key];

      if (!branchField) return false;
      // Handle const matching (standard case)
      if (branchField.hasOwnProperty("const")) {
        return branchField.const === selectedValue;
      }

      if (Array.isArray(branchField.enum)) {
        return branchField.enum.includes(selectedValue);
      }

      // Handle array matching via minItems/maxItems
      if (branchField.type === "array") {
        const actualArray = formData?.[dep.section]?.[dep.key] || [];
        if (
          branchField.minItems !== undefined &&
          actualArray.length >= branchField.minItems
        ) {
          return true;
        }
        if (
          branchField.maxItems !== undefined &&
          actualArray.length <= branchField.maxItems
        ) {
          return true;
        }
      }

      return false;
    });
    if (!matchedBranch) continue;

    if (dep.key === "paymentMethod") {
      const sectionKey = path.find((k) => dep.keys.includes(k));
      if (matchedBranch.properties?.[sectionKey]) {
        updatedFieldSchema = matchedBranch.properties[sectionKey];
        if (updatedFieldSchema?.properties?.[field]) {
          updatedFieldSchema = updatedFieldSchema.properties[field];
        }
      }
    } else if (dep.key === "petsPresent") {
      const sectionKey = path.find((k) => dep.keys.includes(k));
      if (matchedBranch.properties?.[sectionKey]) {
        updatedFieldSchema = matchedBranch.properties[sectionKey];
        if (updatedFieldSchema.type === "array" && updatedFieldSchema.items) {
          updatedFieldSchema = updatedFieldSchema.items;
        }
        if (updatedFieldSchema?.properties?.[field]) {
          updatedFieldSchema = updatedFieldSchema.properties[field];
        }
      }
    } else {
      // Hospice or Home Health
      if (matchedBranch.properties?.[field]) {
        updatedFieldSchema = matchedBranch.properties[field];
        updatedFormData = updatedFormData?.[field];
      }
    }
  }

  return { fieldSchema: updatedFieldSchema, currentFormData: updatedFormData };
}
